"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "resource_item_stock" };
const _hoisted_2 = ["data-tooltip"];
const _hoisted_3 = {
    class: "resource_item_stock_count",
    "data-test": "stock-count"
};
const _hoisted_4 = { class: "resource_item_prod" };
const _hoisted_5 = ["data-tooltip"];
const _hoisted_6 = {
    class: "shield_parent",
    "data-test": "protection-shield"
};
const _hoisted_7 = {
    key: 1,
    class: "shield_production_protection"
};
const _hoisted_8 = {
    key: 2,
    class: "shield_resource_protection"
};
const _hoisted_9 = {
    key: 0,
    class: "resource_icon--megacredit-value",
    "data-test": "resource-value"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["resource_item", _ctx.mainCSS])
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (0, vue_1.createElementVNode)("i", {
                class: (0, vue_1.normalizeClass)(["resource_icon tooltip tooltip-bottom", _ctx.iconCSS]),
                "data-tooltip": _ctx.resourceTypeTooltip
            }, null, 10, _hoisted_2),
            (0, vue_1.createElementVNode)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.count), 1)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_4, [
            (0, vue_1.createElementVNode)("span", {
                class: "resource_item_prod_count tooltip tooltip-bottom",
                "data-test": "production",
                "data-tooltip": _ctx.productionCountTooltip
            }, (0, vue_1.toDisplayString)(_ctx.productionSign) + (0, vue_1.toDisplayString)(_ctx.production), 9, _hoisted_5),
            (0, vue_1.createElementVNode)("div", _hoisted_6, [
                (_ctx.protectionIcon !== '')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_1.normalizeClass)(_ctx.protectionIcon)
                    }, null, 2))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.showProductionProtectedIcon)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.showResourceProtectionIcon)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8))
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (_ctx.showResourceValue())
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, (0, vue_1.toDisplayString)(_ctx.value), 1))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ], 2));
}
